exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-43091e2c] .el-tabs__header{margin-bottom:0}.el-dropdown-link[data-v-43091e2c]{cursor:pointer;color:#90c328}[data-v-43091e2c] #list_table .el-button+.el-button{margin-left:0}", ""]);

// exports
